module.exports = __webpack_public_path__ + "media/images/top/top_pickup_company_06-7a9bf9201be38c91b7aee7553063ce54.png";